import {
    SET_APPROVERCOMMENT,
} from './mmApproversDetailsAction';

const initialState = {
    approverComment: '',

};
const mmApproversDetails = (state = initialState, action) => {
    switch (action.type) {

        case SET_APPROVERCOMMENT:
            return Object.assign({}, state, {
                approverComment: action.value,
            })

        default:
            return state;
    }
}
export default mmApproversDetails;